import styled from 'styled-components'

export const PageContainer = styled.div(({ windowSize, theme }) => ({
  display: 'flex',
  height: windowSize.height,
  [`@media(min-width: ${theme.breakpoints.lg.minWidth})`]: {
    height: windowSize.height
  }
}))
